import styled from "styled-components";
import Roy from "../../../assets/img/icons/roy.svg";
import { Popover } from "antd";
import Button from "./Button";
import { connect, useSelector } from "react-redux";
import { RootState } from "store";
import { getPlanType } from "utils";

const shareEmail = (props: any) => {
  window.open(
    "mailto:support@xiqinc.com?body=" +
    escape("Hi, I would like to know more about Scaleup & Enterprise Packages.")
  );
};

interface ITypes {
  'email': {
    [key: string]: string
  }
  'account': {
    [key: string]: string
  }
}

const Types: ITypes = {
  'email': {
    'heading': 'send emails',
    'description': 'send unlimited emails',
  },
  'account': {
    'heading': 'add more accounts',
    'description': 'add unlimited accounts',
  }
}

interface IPopoverProps {
  isSidebar?: boolean;
  onVisibleChange?: () => void;
  children?: any; // any for adding children
  defaultVisible?: boolean;
  overlayClass?: string;
  isPopoverVisible?: boolean;
  royClickHandler?: () => void;
  hideOverlay?: boolean;
  contentType: 'email' | 'account';
  showRoyIcon?: boolean
}

const FloatingPopover: React.FC<IPopoverProps> = (props) => {
  const selectedIds = useSelector((state: RootState) => state.dragDrop.selectedIds);
  const gillRoyMoveUp = useSelector((state: RootState) => state.dragDrop.gillRoyMoveUp);

  const content =
    getPlanType().toUpperCase() === "ENTERPRISE" ? null : (
      <div style={{ padding: "60px 40px" }}>
        <img src={Roy} alt="" />
        <br />
        <h2>You’ll need to upgrade to {Types[props.contentType].heading}</h2>
        <p>
          The <a style={{ color: " #27CE0A", fontWeight: "bold" }}>ScaleUp</a> and{" "}
          <a style={{ color: " #27CE0A", fontWeight: "bold" }}>Enterprise</a> tiers allow you to&nbsp;
          {Types[props.contentType].description}. Upgrade from the free tier and unlock the full power of xiQ today.
        </p>
        <Button onClick={shareEmail} value="Contact xiQ" />
      </div>
    );

  return (
    <Wrapper>
      {/* {getPlanType().toUpperCase() === "ENTERPRISE" ? null : ( */}
      <Popover
        placement="topRight"
        content={props.children || content}
        trigger="click"
        visible={props.isPopoverVisible}
        {...(props.hideOverlay
          ? {
            overlayClassName: "floating-popover-reminder hide-box-shadow",
          }
          : {
            overlayClassName: props.overlayClass || "floating-popover-reminder",
          })}
        // overlayClassName={props.overlayClass || "floating-popover-reminder"}
        defaultVisible={props.defaultVisible || false}
        onVisibleChange={props.onVisibleChange}
        {...props}
      >
        {/* <div className="progress"></div> */}
        <div
          className={`opener A ${props.isSidebar ? "openFloating" : ""} ${selectedIds.length > 0 || gillRoyMoveUp ? "move-up" : ""
            }`}
        >
          {/* Toggle sidebar-opend Class */}
          {props.showRoyIcon && <img onClick={props.royClickHandler} src={Roy} alt="" />}

        </div>
      </Popover>
      {/* )} */}
    </Wrapper>
  );
};

export default connect()(FloatingPopover);

FloatingPopover.defaultProps = {
  contentType: 'email',
  showRoyIcon: true
}

const Wrapper = styled.div`
  // @keyframes roll {
  //   0% {
  //     transform: rotate(0);
  //   }
  //   100% {
  //     transform: rotate(360deg);
  //   }
  // }
  .move-up {
    bottom: 100px !important;
  }
  .progress {
    position: fixed;
    bottom: 7px;
    right: 7px;
    border-radius: 100%;
    background: #27ce0a;
    width: 76px;
    height: 76px;
    &:before {
      content: "";
      border-radius: 100%;
      position: fixed;
      bottom: 7px;
      right: 7px;
      background: #fff;
      width: 76px;
      height: 76px;
      overflow: hidden;
      // animation: roll 3s infinite;
      clip: rect(0px, 40px, 15px, 0px);
      // transform: rotate(00deg);
    }
    &.complete-0 {
      &:before {
        clip: rect(0px, 40px, 15px, 0px);
      }
    }
    &.complete-25 {
      &:before {
        clip: rect(0px, 40px, 15px, 0px);
      }
    }
    &.complete-50 {
      &:before {
        clip: rect(0px, 40px, 76px, 0px);
      }
    }
    &.complete-60 {
      &:before {
        clip: rect(0px, 40px, 62px, 0px);
      }
    }
    &.complete-75 {
      &:before {
        clip: rect(0px, 40px, 37px, 0px);
      }
    }
    &.complete-80 {
      &:before {
        clip: rect(0px, 40px, 15px, 0px);
      }
    }
    &.complete-100 {
      &:before {
        clip: rect(0px, 40px, 0px, 0px);
      }
    }
  }
  .opener {
    border-radius: 100%;
    position: fixed;
    bottom: 0px;
    right: 28px;
    cursor: pointer;
    z-index: 1;
    padding: 16px 14px 20px 14px;
    transition: 1s;
    /* z-index: 999; */
    z-index: 11;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 12px 10px 12px 10px;
    }
    &.bottom-bar-active {
      bottom: 105px;
    }
    &.progress {
      // &:before {
      //   content: "";
      //   width: 76px;
      //   height: 76px;
      //   position: absolute;
      //   left: -4px;
      //   top: -4px;
      //   background: #27CE0A;
      // }
    }
    &.sidebar-open {
      right: 600px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        right: 450px;
      }
    }
    img {
      width: 40px;
      height: auto;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 30px;
      }
    }
  }
  .openFloating {
    right: 636px;
    /* z-index: 15; */
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      right: 450px;
    }
  }
`;
